import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isServerContext } from '@web/utils';
import { map } from 'rxjs';

export const EveryoneGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const isServer = isServerContext();

  // Po stronie serwera robię tymczasowe przekierowanie na stronę ładowania.
  if (isServer) {
    return false;
  }

  return auth.isLoggedIn().pipe(map(() => true));
};
